import request from "@/utils/request";

/* --------- [数据字典]相关api --------- */
/**
 * [查询][所有]获取 问题标签表-标签类型 字典数据列表
 */
export const getDictDataOfIssueTagType = () => {
    return request.get(`/baseDataIssueTag/sysDictData/tagType`);
}

/** TODO 待后端补充api
 * [查询][所有]获取 物料信息表-物料分类 字典数据列表
 */
export const getDictDataOfMaterialType = () => {
    return request.get(`/xxx/sysDictData/materialType`);
}

/** TODO 待后端补充api
 * [查询][所有]获取 区域管理表-门店类型 字典数据列表
 */
export const getDictDataOfStoreType = () => {
    return request.get(`/xxx/sysDictData/storeType`);
}

/** TODO 待后端补充api
 * [查询][所有]获取 风险类型表-分类级别字典数据列表
 */
export const getDictDataOfRiskTypeLevel = () => {
    return request.get(`/xxx/sysDictData/riskTypeLevel`);
}

/* --------- [组织架构/部门] api --------- */
export const getSysOrganizationPage = (params) => {
    return request.get(`/sysOrganization/page`, { params });
}


/* --------- [数据字典类型管理] api --------- */
/**
 * [查询][分页] 获取字典类型列表
 */
export const getSysDictTypePage = (params) => {
    return request.get(`/sysDictType/page`, { params });
}

/**
 * [查询][单个] 获取字典类型详情
 */
export const getSysDictTypeInfo = (id) => {
    return request.get(`/sysDictType/${id}`);
}

/**
 * [新增] 创建字典类型
 */
export const createSysDictType = (data) => {
    return request.post(`/sysDictType`, data);
}

/**
 * [修改] 更新字典类型
 */
export const updateSysDictType = (id, data) => {
    return request.put(`/sysDictType`, data);
}

/**
 * [删除] 删除字典类型
 */
export const deleteSysDictType = (id) => {
    return request.delete(`/sysDictType/${id}`);
}

/* --------- [数据字典数据管理] api --------- */
/**
 * [查询][分页] 获取字典数据列表
 */
export const getSysDictDataList = () => {
    return request.get(`/sysDictData/list`);
}
/**
 * [查询]获取系统参数列表
 * @param params
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const getSystemOptionList = (params) => {
    return request.get(`/systemData/options`, { params });
}
/**
 * [查询][分页] 获取字典数据列表
 */
export const getSysDictDataPage = (params) => {
    return request.get(`/sysDictData/page`, { params });
}

/**
 * [查询][单个] 获取字典数据详情
 */
export const getSysDictDataInfo = (id) => {
    return request.get(`/sysDictData/${id}`);
}

/**
 * [新增] 创建字典数据
 */
export const createSysDictData = (data) => {
    return request.post(`/sysDictData`, data);
}

/**
 * [修改] 更新字典数据
 */
export const updateSysDictData = (id, data) => {
    return request.put(`/sysDictData`, data);
}

/**
 * [删除] 删除字典数据
 */
export const deleteSysDictData = (id) => {
    return request.delete(`/sysDictData/${id}`);
}

/* --------- [xxx] api --------- */